import VendorService from '@/services/vendor.service.js'

const state = {
  vendors: [],
  loading: false,
  currentVendor: null
}

const getters = {
  vendors: state => state.vendors,
  loading: state => state.loading,
  currentVendor: state => state.currentVendor
}
console.log('Vendor State: ', state)
const actions = {
  async fetchVendors({ commit, dispatch }, params = {}) {
    try {
      commit('SET_LOADING', true)
      const response = await VendorService.getVendors(params)
      const data = response.payload?.responseData || response.payload || response
      commit('SET_VENDORS', data)
      return data
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to load vendors',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchVendorById({ commit, dispatch }, partyId) {
    try {
      commit('SET_LOADING', true)
      const response = await VendorService.getVendorById(partyId)
      const data = response.payload?.responseData || response.payload || response
      commit('SET_CURRENT_VENDOR', data)
      return data
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to load vendor',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createVendor({ commit, dispatch }, payload) {
    try {
      commit('SET_LOADING', true)
      const response = await VendorService.createVendor(payload)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Vendor created successfully',
        { root: true }
      )
      await dispatch('fetchVendors')
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to create vendor',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateVendor({ commit, dispatch }, { partyId, payload }) {
    try {
      commit('SET_LOADING', true)
      const response = await VendorService.updateVendor(partyId, payload)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Vendor updated successfully',
        { root: true }
      )
      await dispatch('fetchVendors')
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to update vendor',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deleteVendor({ commit, dispatch }, partyId) {
    try {
      commit('SET_LOADING', true)
      const response = await VendorService.deleteVendor(partyId)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Vendor deleted successfully',
        { root: true }
      )
      await dispatch('fetchVendors')
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to delete vendor',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  clearCurrentVendor({ commit }) {
    commit('SET_CURRENT_VENDOR', null)
  }
}

const mutations = {
  SET_VENDORS(state, vendors) {
    state.vendors = vendors.vendors
  },
  SET_LOADING(state, value) {
    state.loading = value
  },
  SET_CURRENT_VENDOR(state, vendor) {
    state.currentVendor = vendor
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
